export default __webpack_public_path__ + "static/media/15.42cc344b.jpeg";